import React from 'react';
import { Card, Space, Tag, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../Shared/GlobalContext/ThemeContext';
import { formatFullTime } from '../../../../utils/messageRenderUtils';

const { Text } = Typography;

const MessageEscalationInfo = ({ escalation }) => {
    const { t } = useTranslation();
    const { isDarkMode } = useTheme();

    if (!escalation) return null;

    const themeColors = {
        cardBackground: isDarkMode ? '#1f1f1f' : '#fff',
        text: isDarkMode ? 'rgba(255, 255, 255, 0.85)' : 'rgba(0, 0, 0, 0.88)',
        secondaryText: isDarkMode ? 'rgba(255, 255, 255, 0.65)' : 'rgba(0, 0, 0, 0.45)',
    };

    return (
        <Card title={t('escalation_details')} style={{ background: themeColors.cardBackground }}>
            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                <Text strong style={{ color: themeColors.text }}>{t('customer_query')}:</Text>
                <Text style={{ color: themeColors.text, whiteSpace: 'pre-wrap' }}>{escalation.customer_query}</Text>

                <Space>
                    <Text strong style={{ color: themeColors.text }}>{t('priority')}:</Text>
                    <Tag color={escalation.priority === 'high' ? 'red' : 'orange'}>
                        {escalation.priority}
                    </Tag>
                </Space>

                <Text strong style={{ color: themeColors.text }}>{t('status')}: {escalation.status}</Text>

                {escalation.resolved_at && (
                    <Text style={{ color: themeColors.text }}>
                        {t('resolved_at')}: {formatFullTime(escalation.resolved_at)}
                    </Text>
                )}

                {escalation.resolved_by && (
                    <Text style={{ color: themeColors.text }}>
                        {t('resolved_by')}: {escalation.resolved_by.full_name}
                    </Text>
                )}

                {escalation.admin_response && (
                    <Card type="inner" title={t('admin_response')} style={{ background: themeColors.cardBackground }}>
                        <Space direction="vertical">
                            <Text style={{ color: themeColors.text, whiteSpace: 'pre-wrap' }}>{escalation.admin_response.content}</Text>
                            <Text type="secondary" style={{ color: themeColors.secondaryText }}>
                                {formatFullTime(escalation.admin_response.sent_at)}
                            </Text>
                        </Space>
                    </Card>
                )}

                {escalation.agent_response && (
                    <Card type="inner" title={t('agent_response')} style={{ background: themeColors.cardBackground }}>
                        <Space direction="vertical">
                            <Text style={{ color: themeColors.text, whiteSpace: 'pre-wrap' }}>{escalation.agent_response.content}</Text>
                            <Text type="secondary" style={{ color: themeColors.secondaryText }}>
                                {formatFullTime(escalation.agent_response.sent_at)}
                            </Text>
                        </Space>
                    </Card>
                )}
            </Space>
        </Card>
    );
};

export default MessageEscalationInfo;
